import { render } from "./OrderTabErrorOrderSync.vue?vue&type=template&id=0a032ab7&scoped=true"
import script from "./OrderTabErrorOrderSync.vue?vue&type=script&lang=js"
export * from "./OrderTabErrorOrderSync.vue?vue&type=script&lang=js"

import "./OrderTabErrorOrderSync.vue?vue&type=style&index=0&id=0a032ab7&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a032ab7"]])

export default __exports__